<template>
  <div>
    <div
      class="row no-gutters animate-expand img-container"
      :class="{ active: isActive }"
    >
      <div
        v-for="(_tech, key) in popups"
        :key="key"
        class="img-col col-4 col-md-2 py-3 d-flex justify-content-center"
      >
        <div
          class="img-wrap radial-out"
          title="Click for some tech jibber-jabber"
          @click="openPopup(key)"
        >
          <img :src="imgUrl(key)" />
        </div>
      </div>
    </div>
    <div class="row no-gutters more  pt-5 pb-4 pb-md-0">
      <div class="col-12">
        <h3>And more...</h3>
      </div>
    </div>
    <div class="more-info" :class="{ active: showPopup }">
      <div class="container info-block">
        <div class="row no-gutters col-wrap">
          <div class="col-2 col-md-1">
            <a class="back-btn" @click.capture="showPopup = false">
              <font-awesome-icon icon="arrow-left" size="2x" />
            </a>
          </div>
          <div class="col-10 col-md-11">
            <h2>{{ popContent?.title }}</h2>
          </div>
        </div>
        <div class="row no-gutters col-wrap">
          <div class="col-12">
            <p>{{ popContent?.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showPopup: false,
      popups: {
        node: {
          title: "NodeJS",
          text:
            "It's a go-to option for startups and SaaS products. Node is quite simple in terms of development (Assuming a dev knows his stuff), not too greedy on resources, and gives out great performance and scalability. If you're not too short on time and have big ambitions - This might be one of your best options."
        },
        rails: {
          title: "Ruby on Rails",
          text:
            "If you need to do an MVP lightning fast, or your business logic isn't too tricky - This might be one of your best options. Rails might be a bit behind other platforms in terms of performance, but it compensates with great speed of development and ease of the support. So if you need an MVP or a simple SaaS/CMS/CRM - Rails is one of the fitting options for you."
        },
        laravel: {
          title: "Laravel Framework",
          text:
            "This PHP framework takes a lot of inspiration from Ruby on Rails and even overcomes it in some aspects. The speed of development is still pretty fast, and it can handle some tricky business logic a bit better. So if you're looking for a perfect balance between time, performance, and ease of support - Laravel is your best choice."
        },
        vue: {
          title: "VueJS",
          text:
            'Vue is the "youngest" of top-tier front-end frameworks, but it often works to it\'s advantage. Vue is great for both full-featured single-page apps or as a bunch of micro-apps on separate pages to take the load off some big monolith application.'
        },
        ruby: {
          title: "Ruby",
          text:
            "If you're concerned about Rails speed and customizations - You can consider native Ruby for better performance and long-term maintainability. Plus — you get quite a lot of perks that are used by Rails. Development won't be as fast (though still pretty close), but you'll get easy maintainability and fewer restrictions for more complex business logic."
        },
        js: {
          title: "General purpose JS",
          text:
            "Can provide everything you need from small updates on the website all the way to a chrome extension. Native JS is rarely used standalone. But if you need some cool UI/UX tweaks for your product - We can do it."
        },
        docker: {
          title: "Docker",
          text:
            "Once your awesome product is ready - comes the part of shipping it and deploying it to a live server. And that's where the Docker shines the most. Docker is a platform that allows you to ship your products in an isolated environments, called containers. All my projects are docker-compatible, as I always use docker from the very start. You don't have to use it, but you'll know it's there whenever you need it."
        },
        aws: {
          title: "Amazon Web Services",
          text:
            "A well-known computing platform. It's a great fit for anything from a simple landing page to a top-tier, complex eco-system of different products. Whatever you may need - a server, a cloud function, a database, or storage - AWS always delivers. And even though it requires some level of knowledge to operate - AWS can become home for your product."
        },
        git: {
          title: "Git",
          text:
            "In a modern world, using version-control is so obvious that I doubted if it's a good idea to list it here. But I do know that sometimes people are using git just for the sake of using it. But there's a lot more to it. When used right - Git can be a great way to work in a team. It also can be used to build efficient deployment processes. So when done right - git is a bit more than just a version control system."
        },
        firebase: {
          title: "Firebase",
          text:
            "Firebase is not just a database. It can replace your entire backend. If you need to quickly kick-off with a new product - Firebase is one of the appealing options. And if firebase can't satisfy some of your needs - we can extend it with serverless cloud functions (That are also a part of the firebase ecosystem). While this may not be the first choice for large/complex products, Firebase can fit in great if you want to start fast and easy."
        },
        mysql: {
          title: "MySQL Database",
          text:
            "MySQL is one of the most common relational (with fixed data structure) databases. When configured right - this database will provide good speed and can store huge amounts of data without killing performance. You always need to account for specific requirements, but whatever you're building - there's a good chance that MySQL will be a good fit."
        },
        pg: {
          title: "PostgreSQL",
          text:
            "Another popular relational (with fixed data structure) database. It might be just a bit slower than MySQL in terms of performance (Mostly for read operations). But it handles write operations well and provides a better concurrency. But it also shines in a different area. With Postgres - we get more complex data types in addition to basic ones. On top of that - we can search/filter and group using those types. So if your product needs a complex data structure, or some advanced search/filtering - You should definitely consider PostgreSQL."
        }
      },
      popContent: {}
    };
  },
  methods: {
    openPopup(name) {
      this.popContent = this.popups[name];
      this.showPopup = true;
    },
    imgUrl(name) {
      return require(`@/assets/img/tech/${name}.png`);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./tech-stack";
</style>
